import {
    generateHomeCards,
    generateSidebarWithNestedPermissions,
    generateSidebarWithPlainPermissions
} from "@/common/lib/permissions";
import {
    applyTenantStackColors,
    isStackColorsMode
} from "@/common/lib/stack-colors";

const mutations = {
    UPDATED_ACTIVE_SOUND_MODE(state, payload) {
        state.activeSound = payload;
    },
    UPDATE_SIDEBAR_STATE(state, payload) {
        state.activeSidebar = payload;
    },
    UPDATED_LOADING_STATE(state, payload) {
        state.loading = payload;
    },
    UPDATED_ACTIVE_DARK_MODE(state, payload) {
        state.activeDark = payload;
    },
    SET_SIDEBAR_ITEMS(state, payload) {
        state.sidebarItems = [...payload];
    },
    CLEAR_SIDEBAR(state) {
        state.sidebarItems = [];
    },
    APPLY_SIDEBAR_ITEMS(state, permissions = []) {
        state.sidebarItems =
            permissions.length <= 20
                ? generateSidebarWithPlainPermissions(permissions)
                : generateSidebarWithNestedPermissions(permissions);
    },
    APPLY_HOME_CARDS_LINKS(state, permissions) {
        const { cardLinksActive, cardLinksAvailable } =
            generateHomeCards(permissions);
        state.cardLinksAvailable = cardLinksAvailable;
        state.cardLinksActive = cardLinksActive;
        state.cardLinksReviewed = state.cardLinksReviewed.filter((link) =>
            cardLinksAvailable.some(
                (availableLink) => availableLink.url === link.url
            )
        );
        state.cardLinksFavorites = state.cardLinksFavorites.filter((link) =>
            cardLinksAvailable.some(
                (availableLink) => availableLink.url === link.url
            )
        );
    },
    // portal-sesion-y-candados-optimizacion: guarda los colores del tenant y
    // los aplica a la interfaz (las variables CSS no sobreviven a una
    // recarga; el layout vuelve a commitear lo guardado al montar).
    SET_TENANT_STACK_COLORS(state, stackColors) {
        state.tenantStackColors = stackColors || null;
        if (isStackColorsMode()) {
            applyTenantStackColors(state.tenantStackColors);
        }
    },
    SET_OPERATION_MODE(state, operationMode) {
        state.operationMode = operationMode;
    },
    CLEAR_RECENT_LINK(state) {
        state.cardLinksReviewed = [];
    },
    PUSH_RECENT_LINK(state, cardLink) {
        state.cardLinksReviewed.unshift(cardLink);

        state.cardLinksReviewed = state.cardLinksReviewed.filter(
            (item, index, self) =>
                index < 12 &&
                self.findIndex((el) => el.url === item.url) === index
        );
    },
    TOGGLE_FAVORITE_LINK(state, cardLink) {
        const isFavorite = state.cardLinksFavorites.some(
            (item) => item.url === cardLink.url
        );
        if (isFavorite) {
            state.cardLinksFavorites = state.cardLinksFavorites.filter(
                (item) => item.url !== cardLink.url
            );
            return;
        }
        state.cardLinksFavorites.unshift(cardLink);
    }
};

export default mutations;
